import { z } from 'zod'

export const categorySchema = z.object({
  id: z.string().or(z.number()),
  category_code: z.string(),
  name: z.string(),
  country_code: z.string(),
  lang_code: z.string(),
})

export type Category = z.infer<typeof categorySchema>

export const categoriesResponseSchema = z.array(categorySchema)

export type CategoriesResponse = z.infer<typeof categoriesResponseSchema>
